import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TabViewModule } from "@bfx/primeng/tabview";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { MenuModule } from "@bfx/primeng/menu";
import { ButtonModule } from "@bfx/primeng/button";
import { CalendarModule } from "@bfx/primeng/calendar";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { DfPriceSpinner } from "./editors/DfPriceSpinner";
import { DfAmountSpinner } from "./editors/DfAmountSpinner";
import { DfCheckBox } from "./editors/DfCheckBox";
import { MarketSpotSpinner } from "./editors/MarketSpotSpinner";
import { MarketPtsSpinner } from "./editors/MarketPtsSpinner";
import { MarketAllInSpinner } from "./editors/MarketAllInSpinner";
import { ClientSpotSpinner } from "./editors/ClientSpotSpinner";
import { ClientPtsSpinner } from "./editors/ClientPtsSpinner";
import { ClientAllInSpinner } from "./editors/ClientAllInSpinner";
import { DetailFillRateSpinner } from "./editors/DetailFillRateSpinner";
import { VehicleCcyAuto } from "./editors/VehicleCcyAuto";
import { PosBookAuto } from "./editors/PosBookAuto";
import { DfAutoComplete } from "./editors/DfAutoComplete";
import { TenorDfAutoComplete } from "./editors/TenorDfAutoComplete";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { DfCalendarComponent } from "./editors/DfCalendar";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";
import { CubiqServicesPrimaryModule } from "../../shared/cubiq-services/module/CubiqServicesPrimaryModule";

@NgModule({
  imports: [
    BfxSharedModule,
    CommonModule,
    TranslateModule,
    CubiqServicesPrimaryModule,
    BfxElementsLibraryModule,
    TabViewModule,
    AgGridModule,
    MenuModule,
    CheckboxModule,
    FormsModule,
    ButtonModule,
    NativeDesktopModule,
    PerfectScrollbarModule,
    CalendarModule,
    BaseComponentsModule,
  ],
  declarations: [
    DfPriceSpinner,
    DetailFillRateSpinner,
    DfAmountSpinner,
    DfCheckBox,
    DfAutoComplete,
    PosBookAuto,
    MarketSpotSpinner,
    MarketPtsSpinner,
    MarketAllInSpinner,
    ClientSpotSpinner,
    ClientPtsSpinner,
    ClientAllInSpinner,
    VehicleCcyAuto,
    DfCalendarComponent,
    TenorDfAutoComplete,
  ],
  providers: [],
  exports: [
    DfPriceSpinner,
    DfAmountSpinner,
    DfCheckBox,
    DfAutoComplete,
    PosBookAuto,
    DetailFillRateSpinner,
    MarketSpotSpinner,
    MarketPtsSpinner,
    MarketAllInSpinner,
    ClientSpotSpinner,
    ClientPtsSpinner,
    ClientAllInSpinner,
    VehicleCcyAuto,
    DfCalendarComponent,
    TenorDfAutoComplete,
  ],
  bootstrap: [
    DfPriceSpinner,
    DfAmountSpinner,
    DfCheckBox,
    DfAutoComplete,
    PosBookAuto,
    MarketSpotSpinner,
    MarketPtsSpinner,
    MarketAllInSpinner,
    ClientSpotSpinner,
    ClientPtsSpinner,
    ClientAllInSpinner,
    VehicleCcyAuto,
    DfCalendarComponent,
    TenorDfAutoComplete,
  ],
})
export class BfxDetailFillEditorsModule {}
